const BASE_URL = "https://wenmarnonline.com/api";
// const BASE_URL = "http://localhost:8080";
export default BASE_URL;
